import { render, staticRenderFns } from "./ControlPropertiesActes.vue?vue&type=template&id=cb0da4e2&"
import script from "./ControlPropertiesActes.vue?vue&type=script&lang=js&"
export * from "./ControlPropertiesActes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports